const auth = [
	// {
	//   //等级展示
	//   path: '/guide',
	//   name: 'guide',
	//   component: (resolve) =>
	//     require(['@/views/personal/authentication/index'], resolve),
	//   meta: {
	//     isHide: true,
	//   },
	// },
]

export default auth
